var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"60px"},attrs:{"alt":this.bk,"title":this.bk,"src":require('@/assets/bk/' + _vm.source)}})}
var staticRenderFns = []

export { render, staticRenderFns }